import React from 'react';

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

// Shared wrapper for the legal pages. Centralizes the page chrome and the
// typographic styling of nested h2/h3/p/ul/a/table so each page only ships its
// content. Fully dark-mode aware via semantic tokens.
const LegalLayout: React.FC<LegalLayoutProps> = ({ title, lastUpdated, children }) => (
  <div className="container mx-auto mt-20 max-w-4xl px-4 py-16">
    <h1 className="mb-2 font-heading text-3xl font-bold text-text-primary sm:text-4xl">{title}</h1>
    <p className="mb-10 text-sm text-text-secondary">Ultimo aggiornamento: {lastUpdated}</p>
    <div
      className="space-y-5 text-base leading-relaxed text-text-secondary sm:text-lg
        [&_a]:font-medium [&_a]:text-primary [&_a]:underline
        [&_h2]:mb-3 [&_h2]:mt-10 [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-text-primary
        [&_h3]:mb-2 [&_h3]:mt-6 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-text-primary
        [&_li]:mb-1 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-6
        [&_strong]:text-text-primary"
    >
      {children}
    </div>
  </div>
);

export default LegalLayout;
